var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lv-base-column',_vm._b({ref:"column",scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
var rowIndex = ref.rowIndex;
var col = ref.col;
var colIndex = ref.colIndex;
var editRow = ref.editRow;
var fixedRow = ref.fixedRow;
return [(!fixedRow)?_c('link-table-cell-normal',{attrs:{"text":(_vm.currentPage-1)*_vm.pageSize + (rowIndex+1),"data":{row: row,rowIndex: rowIndex,col: col,colIndex: colIndex,editRow: editRow,fixedRow: fixedRow,}}}):_c('div',{staticClass:"lv-table-cell-normal lv-base-column-fixed-row-text"},[_vm._v("\n\t\t\t"+_vm._s(_vm.fixedRowText)+"\n\t\t")])]}}])},'lv-base-column',_vm.columnBinding,false))}
var staticRenderFns = []

export { render, staticRenderFns }